const accountAnalytic = {
  number: {
    label: "Numéro",
  }
};

export default accountAnalytic;
